import Utils from '../common/Utils';
import SeriesList from './components/SeriesList';
import RemoteControll from "./components/RemoteControll";
/**
 * library의 시작점
 * @category library
 * @memberof module:library
 * @param  {Object} _config={} 설정 옵션
 */
class App {
  constructor(_config = {}) {
    this.config = Object.assign({}, _config);
  }

  init() {
    let aliasName = '';
    for (let key in this.config.categoryList) {
      if(this.config.categoryId == this.config.categoryList[key]) aliasName = key;
    }
    const seriesList = new SeriesList({id:aliasName}, this.config.seriesEl, this.config.categoryList);

    for (let el of document.querySelectorAll(this.config.introEl)) {
      if(el.dataset.aliasName != aliasName){
        el.remove();
      }else{
        el.classList.add('is-active');
      };
    }
    if(aliasName == '' || aliasName == undefined) document.querySelector('#cartoonIntro').remove();

    if(this.config.device != 'ingame' && aliasName != ''){
      //console.log(`share ${aliasName}`)
      // const commuintyShare = new nc.uikit.Share({
      //   nodeId: `share${aliasName}`,
      //   order: ["facebook", "twitter","url"]
      // });
      var share = new window.ncui.share({
        snsOrder: ['facebook', 'twitter', 'copy'],
        title: '글을 SNS에 공유해보세요.',
        dimmed: false,
        useNavigatorShare: true,
        shareUrl: window.location.href,
        btnShareTrigger: {
          selector: '.btn-share'
        },
        breakpoint: {
          '360': {
            title: '360.',
            dimmed: false,
            shareUrl: 'asd',
            btnShareTrigger: {
              selector: '.btn-share',
            },
          }
        }
      });
    }
  }
}
Utils.namespace('nc.bns.library');
nc.bns.library = App;


class View {
  constructor(_config = {}) {
    this.config = Object.assign({}, _config);
    const remoteControll = new RemoteControll({
      fixedSpaceTop:197,
      fixedSpaceBottom:212,
      srollSpeed:300,
    }, '.contents-wrapper');
  }
}
Utils.namespace('nc.bns.library.view');
nc.bns.library.view = View ;
